/* eslint-disable react/jsx-props-no-spreading */
import { Component } from 'react';
import { GoogleMap, LoadScript } from '@react-google-maps/api';
import { connect } from 'react-redux';
import Markers from './Markers';
import Clusters from './Clusters';
import mapStyles from '../assets/mapStyles.json';
import mapblocksAndZoomLevelArray from '../utils/createMapblocksAndZoomLevelArray';
import fetchStation from '../store/station/action/fetchStation';
import screenDiameterCalculationInCm from '../utils/diameterCalculationInCm';
import distanceCalculationInMeter from '../utils/distanceCalculationInMeter';
import zoomLevelCalculationViaDistances from '../utils/zoomLevelCalculation';
import {
  MapBlockKeyIndexLatFrom,
  MapBlockKeyIndexLngFrom,
} from '../utils/mapBlockCalculation';
import i18next from '../locales';

// Styles for the map container
const containerStyle = {
  width: '100%',
  height: '100%',
};

const defaultMapOptions = {
  styles: mapStyles,
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
  minZoom: 4,
  maxZoom: 22,
};

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultLang: false,
      mapInstance: null,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate() {
    const { defaultLocale } = this.props;
    const { defaultLang } = this.state;
    if (defaultLang === false) {
      i18next.changeLanguage(defaultLocale);
      // eslint-disable-next-line react/no-will-update-set-state
      this.setState({ defaultLang: true });
    }
  }

  onMapLoad = (map) => {
    this.setState({ mapInstance: map });
  };

  onMapIdle = () => {
    const { station } = this.props;
    const { mapInstance } = this.state;

    if (!mapInstance) return;

    const bounds = mapInstance.getBounds();
    if (!bounds) return;

    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const distanceInM = distanceCalculationInMeter(
      ne.lat(),
      ne.lng(),
      sw.lat(),
      sw.lng(),
    );

    const mapDiv = document.getElementById('map');
    const distanceInCm = screenDiameterCalculationInCm(
      mapDiv ? mapDiv.offsetWidth : 0,
      mapDiv ? mapDiv.offsetHeight : 0,
    );

    const zoomLevel = zoomLevelCalculationViaDistances(
      distanceInCm,
      distanceInM,
    );

    const neLatBlock = MapBlockKeyIndexLatFrom(
      ne.lat(),
      zoomLevelCalculationViaDistances(distanceInCm, distanceInM),
    );
    const swLatBlock = MapBlockKeyIndexLatFrom(
      sw.lat(),
      zoomLevelCalculationViaDistances(distanceInCm, distanceInM),
    );

    const neLngBlock = MapBlockKeyIndexLngFrom(
      ne.lng(),
      zoomLevelCalculationViaDistances(distanceInCm, distanceInM),
    );
    const swLngBlock = MapBlockKeyIndexLngFrom(
      sw.lng(),
      zoomLevelCalculationViaDistances(distanceInCm, distanceInM),
    );

    const indexLatMin = neLatBlock < swLatBlock ? neLatBlock : swLatBlock;
    const indexLatMax = neLatBlock < swLatBlock ? swLatBlock : neLatBlock;

    const indexLngMin = neLngBlock < swLngBlock ? neLngBlock : swLngBlock;
    const indexLngMax = neLngBlock < swLngBlock ? swLngBlock : neLngBlock;

    const mapBlocksAndZoomlevel = mapblocksAndZoomLevelArray(
      indexLatMin,
      indexLatMax,
      indexLngMin,
      indexLngMax,
      zoomLevel,
    );

    station(mapBlocksAndZoomlevel);
  };

  render() {
    const {
      checkIFrame,
      center,
      brandColorPreview,
    } = this.props;

    const { mapInstance } = this.state;

    return (
      <div style={{
        height: '100%',
        width: '100%',
        position: 'absolute',
      }}
      >
        <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}>
          <GoogleMap
            id="map"
            mapContainerStyle={containerStyle}
            center={center}
            zoom={13}
            options={defaultMapOptions}
            onLoad={this.onMapLoad}
            onIdle={this.onMapIdle}
          >
            {mapInstance && (
              <>
                <Clusters map={mapInstance} />
                <Markers
                  checkIFrame={checkIFrame}
                  map={mapInstance}
                  brandColorPreview={brandColorPreview}
                />
              </>
            )}
          </GoogleMap>
        </LoadScript>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  is_fetching: state.station.is_fetching,
  center: state.customization.host.webAppCenter,
  defaultLocale: state.customization.host.defaultLocale,
});

const mapDispatchToProps = (dispatch) => ({
  station: (data) => dispatch(fetchStation(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Map);
